import { frontendURL } from 'dashboard/helper/URLHelper';
import SimuladorIndex from './Index.vue';

// v106: Simulador CLT como MENU (standalone, sem conversa). A visibilidade é
// decidida pelo Controle de Acesso (key 'Simulador Menu' — guard central v105);
// as permissions abaixo são só o fallback padrão.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/simulador'),
    name: 'simulador_index',
    component: SimuladorIndex,
    meta: {
      permissions: [
        'administrator',
        'supervisor',
        'agent',
        'operacional',
        'qualidade',
        'ouvidoria',
        'juridico',
        'custom_role',
      ],
    },
  },
];

export default { routes };
